import { render, staticRenderFns } from "./Race.vue?vue&type=template&id=e5c4070e&scoped=true&"
import script from "./Race.vue?vue&type=script&lang=ts&"
export * from "./Race.vue?vue&type=script&lang=ts&"
import style0 from "./Race.vue?vue&type=style&index=0&id=e5c4070e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c4070e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VProgressCircular,VTab,VTabItem,VTabs})
